import { CDN_MARKETPLACE } from '../scene/assets/baseUrl';

const pack1 = [
  {
    name: 'AR_bush_001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_bush_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_bush_001.jpg`,
  },
  {
    name: 'AR_bush_002',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_bush_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_bush_002.jpg`,
  },
  {
    name: 'AR_Flowers_001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_Flowers_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_Flowers_001.jpg`,
  },
  {
    name: 'AR_Flowers_002',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_Flowers_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_Flowers_002.jpg`,
  },
  {
    name: 'AR_Flowers_003',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_Flowers_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_Flowers_003.jpg`,
  },
  {
    name: 'AR_Flowers_004',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_Flowers_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_Flowers_004.jpg`,
  },
  {
    name: 'AR_Flowers_005',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_Flowers_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_Flowers_005.jpg`,
  },
  {
    name: 'AR_grass_001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_grass_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_grass_001.jpg`,
  },
  {
    name: 'AR_grass_002',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_grass_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_grass_002.jpg`,
  },
  {
    name: 'AR_grass_003',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/AR_grass_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/AR_grass_003.jpg`,
  },
  {
    name: 'BG_halloween_town_wood_fence_long',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/BG_halloween_town_wood_fence_long.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/BG_halloween_town_wood_fence_long.jpg`,
  },
  {
    name: 'BG_halloween_town_wood_fence_short',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/BG_halloween_town_wood_fence_short.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/BG_halloween_town_wood_fence_short.jpg`,
  },
  {
    name: 'BPM_SetB_toolbox_001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/BPM_SetB_toolbox_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/BPM_SetB_toolbox_001.jpg`,
  },
  {
    name: 'Cam_AR_bush_002',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/Cam_AR_bush_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/Cam_AR_bush_002.jpg`,
  },
  {
    name: 'Cam_AR_grass_001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/Cam_AR_grass_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/Cam_AR_grass_001.jpg`,
  },
  {
    name: 'Cam_AR_grass_002',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/Cam_AR_grass_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/Cam_AR_grass_002.jpg`,
  },
  {
    name: 'Cam_AR_grass_003',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/Cam_AR_grass_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/Cam_AR_grass_003.jpg`,
  },
  {
    name: 'CBS_Aobj_paddle',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Aobj_paddle.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Aobj_paddle.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Table',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_Table.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_Table.jpg`,
  },
  {
    name: 'CBS_cafe_1F_TableChair',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_TableChair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_TableChair.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Tree',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_Tree.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_Tree.jpg`,
  },
  {
    name: 'CBS_cafe_1F_TreeChair',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_TreeChair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_TreeChair.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Wall_Summer',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_Wall_Summer.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_Wall_Summer.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Wall',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_1F_Wall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_1F_Wall.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Chair',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F_Chair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F_Chair.jpg`,
  },
  {
    name: 'CBS_cafe_2F_SideTable',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F_SideTable.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F_SideTable.jpg`,
  },
  {
    name: 'CBS_cafe_2F_SideWall',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F_SideWall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F_SideWall.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Table',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F_Table.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F_Table.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Tree',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F_Tree.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F_Tree.jpg`,
  },
  {
    name: 'CBS_cafe_2F',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_2F.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_2F.jpg`,
  },
  {
    name: 'CBS_cafe_Flowerpot_S',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_Flowerpot_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_Flowerpot_S.jpg`,
  },
  {
    name: 'CBS_cafe_Light_LoofTop',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_Light_LoofTop.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_Light_LoofTop.jpg`,
  },
  {
    name: 'CBS_cafe_Light_Stand',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_Light_Stand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_Light_Stand.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk_coffepot',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_MainDesk_coffepot.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_MainDesk_coffepot.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk_galss',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_MainDesk_galss.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_MainDesk_galss.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_MainDesk.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_MainDesk.jpg`,
  },
  {
    name: 'CBS_cafe_MenuSign',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_MenuSign.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_MenuSign.jpg`,
  },
  {
    name: 'CBS_cafe_pos',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_pos.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_pos.jpg`,
  },
  {
    name: 'CBS_cafe_Stair',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_cafe_Stair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_cafe_Stair.jpg`,
  },
  {
    name: 'CBS_Fall_Leaf',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Fall_Leaf.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Fall_Leaf.jpg`,
  },
  {
    name: 'CBS_Fall_Leaf001',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Fall_Leaf001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Fall_Leaf001.jpg`,
  },
  {
    name: 'CBS_ground_bridge_1',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_ground_bridge_1.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_ground_bridge_1.jpg`,
  },
  {
    name: 'CBS_ground_bridge_2',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_ground_bridge_2.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_ground_bridge_2.jpg`,
  },
  {
    name: 'CBS_Ground_CheckWall',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground_CheckWall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground_CheckWall.jpg`,
  },
  {
    name: 'CBS_Ground_cliff',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground_cliff.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground_cliff.jpg`,
  },
  {
    name: 'CBS_Ground_hill',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground_hill.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground_hill.jpg`,
  },
  {
    name: 'CBS_ground_outside_sky',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_ground_outside_sky.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_ground_outside_sky.jpg`,
  },
  {
    name: 'CBS_Ground_rock_BIG',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground_rock_BIG.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground_rock_BIG.jpg`,
  },
  {
    name: 'CBS_Ground_rock_BIG2',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground_rock_BIG2.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground_rock_BIG2.jpg`,
  },
  {
    name: 'CBS_Ground',
    url: `${CDN_MARKETPLACE}/zepeto-collections/models/CBS_Ground.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/preview/CBS_Ground.jpg`,
  },
];

const commonObject = [
  {
    name: 'plant_A_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_A_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_A_001.jpg`,
  },
  {
    name: 'plant_A_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_A_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_A_002.jpg`,
  },
  {
    name: 'plant_A_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_A_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_A_003.jpg`,
  },
  {
    name: 'plant_B_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_B_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_B_003.jpg`,
  },
  {
    name: 'plant_B_010.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_B_010.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_B_010.jpg`,
  },
  {
    name: 'plant_B_011.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_B_011.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_B_011.jpg`,
  },
  {
    name: 'plant_C_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_C_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_C_001.jpg`,
  },
  {
    name: 'plant_C_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_C_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_C_004.jpg`,
  },
  {
    name: 'plant_C_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_C_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_C_005.jpg`,
  },
  {
    name: 'plant_E_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/plant_E_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/[CommonObject]/Preview/plant_E_002.jpg`,
  },
];

const sample = [
  {
    name: 'pool_water.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/pool_water.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/pool_water.jpg`,
  },
  {
    name: 'summer_plam_plant.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_plam_plant.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_plam_plant.jpg`,
  },
  {
    name: 'summer_plam.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_plam.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_plam.jpg`,
  },
  {
    name: 'summer_plant.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_plant.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_plant.jpg`,
  },
  {
    name: 'summer_pool_FX.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_pool_FX.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_pool_FX.jpg`,
  },
  {
    name: 'summer_sand.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_sand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_sand.jpg`,
  },
  {
    name: 'summer_tile_dark.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_tile_dark.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_tile_dark.jpg`,
  },
  {
    name: 'summer_tile_light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_tile_light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_tile_light.jpg`,
  },
  {
    name: 'summer_tile_wood.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/summer_tile_wood.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/000_Sample/Preview/summer_tile_wood.jpg`,
  },
];

const desert = [
  {
    name: 'BG_halloween_town_wood_fence_long.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/BG_halloween_town_wood_fence_long.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/BG_halloween_town_wood_fence_long.jpg`,
  },
  {
    name: 'BG_halloween_town_wood_fence_short.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/BG_halloween_town_wood_fence_short.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/BG_halloween_town_wood_fence_short.jpg`,
  },
  {
    name: 'BPM_SetB_toolbox_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/BPM_SetB_toolbox_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/BPM_SetB_toolbox_001.jpg`,
  },
  {
    name: 'IT_Bunker_door.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Bunker_door.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Bunker_door.jpg`,
  },
  {
    name: 'IT_Ground_bigsand_L.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_bigsand_L.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_bigsand_L.jpg`,
  },
  {
    name: 'IT_Ground_bigsand_M.glb',
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_bigsand_M.jpg`,
  },
  {
    name: 'IT_Ground_bigsand_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_bigsand_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_bigsand_S.jpg`,
  },
  {
    name: 'IT_Ground_Rock_L.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_Rock_L.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_Rock_L.jpg`,
  },
  {
    name: 'IT_Ground_Rock_M.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_Rock_M.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_Rock_M.jpg`,
  },
  {
    name: 'IT_Ground_Rock_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_Rock_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_Rock_S.jpg`,
  },
  {
    name: 'IT_Ground_Rock_SS.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_Rock_SS.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_Rock_SS.jpg`,
  },
  {
    name: 'IT_Ground_skyline.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_skyline.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_skyline.jpg`,
  },
  {
    name: 'IT_Ground_under.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_Ground_under.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_Ground_under.jpg`,
  },
  {
    name: 'IT_obj_drum_gray.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_obj_drum_gray.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_obj_drum_gray.jpg`,
  },
  {
    name: 'IT_obj_drum_red.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_obj_drum_red.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_obj_drum_red.jpg`,
  },
  {
    name: 'IT_obj_junk car.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/IT_obj_junk car.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/IT_obj_junk car.jpg`,
  },
  {
    name: 'RPG_Box_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/RPG_Box_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/RPG_Box_002.jpg`,
  },
  {
    name: 'SNP_Stairs_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/SNP_Stairs_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/001_Desert/Preview/SNP_Stairs_001.jpg`,
  },
];

const sakura = [
  {
    name: 'Ground_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Ground_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Ground_002.jpg`,
  },
  {
    name: 'Lantern_A_01Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_A_01Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_A_01Light.jpg`,
  },
  {
    name: 'Lantern_A_02Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_A_02Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_A_02Light.jpg`,
  },
  {
    name: 'Lantern_C_01LIght.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_C_01LIght.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_C_01LIght.jpg`,
  },
  {
    name: 'Lantern_C_02LIght.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_C_02LIght.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_C_02LIght.jpg`,
  },
  {
    name: 'Lantern_C_03Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_C_03Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_C_03Light.jpg`,
  },
  {
    name: 'Lantern_C_04LIght.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_C_04LIght.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_C_04LIght.jpg`,
  },
  {
    name: 'Lantern_D_01Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_D_01Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_D_01Light.jpg`,
  },
  {
    name: 'Lantern_D_02Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_D_02Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_D_02Light.jpg`,
  },
  {
    name: 'Lantern_D_03Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Lantern_D_03Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Lantern_D_03Light.jpg`,
  },
  {
    name: 'LanternLine_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/LanternLine_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/LanternLine_01.jpg`,
  },
  {
    name: 'LanternLine_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/LanternLine_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/LanternLine_02.jpg`,
  },
  {
    name: 'Line014.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Line014.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Line014.jpg`,
  },
  {
    name: 'Line108.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Line108.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Line108.jpg`,
  },
  {
    name: 'Line183.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Line183.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/Line183.jpg`,
  },
  {
    name: 'SK_Bamboo_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bamboo_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bamboo_001.jpg`,
  },
  {
    name: 'SK_Bell_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bell_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bell_001.jpg`,
  },
  {
    name: 'SK_Bench.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bench.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bench.jpg`,
  },
  {
    name: 'SK_Blind_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Blind_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Blind_001.jpg`,
  },
  {
    name: 'SK_Box_fabric.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Box_fabric.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Box_fabric.jpg`,
  },
  {
    name: 'SK_Box_wood.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Box_wood.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Box_wood.jpg`,
  },
  {
    name: 'SK_Brazier.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Brazier.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Brazier.jpg`,
  },
  {
    name: 'SK_Bridge_A.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bridge_A.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bridge_A.jpg`,
  },
  {
    name: 'SK_Bridge_A001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bridge_A001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bridge_A001.jpg`,
  },
  {
    name: 'SK_Bucket_A_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bucket_A_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bucket_A_01.jpg`,
  },
  {
    name: 'SK_Bucket_A_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bucket_A_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bucket_A_02.jpg`,
  },
  {
    name: 'SK_Bucket_A_03.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bucket_A_03.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bucket_A_03.jpg`,
  },
  {
    name: 'SK_Bucket_B_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Bucket_B_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Bucket_B_01.jpg`,
  },
  {
    name: 'SK_Chair_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Chair_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Chair_001.jpg`,
  },
  {
    name: 'SK_Chair_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Chair_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Chair_002.jpg`,
  },
  {
    name: 'SK_Cushion_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Cushion_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Cushion_001.jpg`,
  },
  {
    name: 'SK_Cushion_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Cushion_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Cushion_002.jpg`,
  },
  {
    name: 'SK_Daruma_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Daruma_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Daruma_001.jpg`,
  },
  {
    name: 'SK_DistantView_000.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_DistantView_000.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_DistantView_000.jpg`,
  },
  {
    name: 'SK_DistantView_000b.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_DistantView_000b.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_DistantView_000b.jpg`,
  },
  {
    name: 'SK_DistantView_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_DistantView_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_DistantView_001.jpg`,
  },
  {
    name: 'SK_DistantView_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_DistantView_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_DistantView_002.jpg`,
  },
  {
    name: 'SK_DoorWhite.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_DoorWhite.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_DoorWhite.jpg`,
  },
  {
    name: 'SK_Drum.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Drum.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Drum.jpg`,
  },
  {
    name: 'SK_FoldingFan_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_FoldingFan_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_FoldingFan_001.jpg`,
  },
  {
    name: 'SK_Food_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Food_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Food_001.jpg`,
  },
  {
    name: 'SK_Food_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Food_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Food_002.jpg`,
  },
  {
    name: 'SK_Food_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Food_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Food_003.jpg`,
  },
  {
    name: 'SK_Food_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Food_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Food_004.jpg`,
  },
  {
    name: 'SK_Food_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Food_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Food_005.jpg`,
  },
  {
    name: 'SK_Frog_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Frog_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Frog_001.jpg`,
  },
  {
    name: 'SK_Furniture_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Furniture_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Furniture_001.jpg`,
  },
  {
    name: 'SK_Furniture_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Furniture_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Furniture_002.jpg`,
  },
  {
    name: 'SK_Gate.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Gate.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Gate.jpg`,
  },
  {
    name: 'SK_House.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_House.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_House.jpg`,
  },
  {
    name: 'SK_HouseDoor_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_HouseDoor_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_HouseDoor_001.jpg`,
  },
  {
    name: 'SK_IronPot.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_IronPot.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_IronPot.jpg`,
  },
  {
    name: 'SK_Lamp_002.glb',
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lamp_002.jpg`,
  },
  {
    name: 'SK_Lamp_003_light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lamp_003_light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lamp_003_light.jpg`,
  },
  {
    name: 'SK_Lamp_004_light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lamp_004_light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lamp_004_light.jpg`,
  },
  {
    name: 'SK_Lamp_yellowlight.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lamp_yellowlight.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lamp_yellowlight.jpg`,
  },
  {
    name: 'SK_Lantern_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lantern_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lantern_001.jpg`,
  },
  {
    name: 'SK_Lantern_002_Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lantern_002_Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lantern_002_Light.jpg`,
  },
  {
    name: 'SK_Lncense_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Lncense_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Lncense_001.jpg`,
  },
  {
    name: 'SK_Mandolin_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Mandolin_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Mandolin_001.jpg`,
  },
  {
    name: 'SK_Manekineko_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Manekineko_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Manekineko_001.jpg`,
  },
  {
    name: 'SK_Mask_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Mask_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Mask_001.jpg`,
  },
  {
    name: 'SK_Mirror_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Mirror_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Mirror_001.jpg`,
  },
  {
    name: 'SK_onsen_bath.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_onsen_bath.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_onsen_bath.jpg`,
  },
  {
    name: 'SK_onsen_bottom.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_onsen_bottom.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_onsen_bottom.jpg`,
  },
  {
    name: 'SK_onsen_tray.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_onsen_tray.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_onsen_tray.jpg`,
  },
  {
    name: 'SK_onsen_water.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_onsen_water.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_onsen_water.jpg`,
  },
  {
    name: 'SK_onsen.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_onsen.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_onsen.jpg`,
  },
  {
    name: 'SK_PalntD_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_PalntD_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_PalntD_001.jpg`,
  },
  {
    name: 'SK_parasol.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_parasol.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_parasol.jpg`,
  },
  {
    name: 'SK_Partition_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Partition_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Partition_001.jpg`,
  },
  {
    name: 'SK_Picture_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_001.jpg`,
  },
  {
    name: 'SK_Picture_002_pic.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_002_pic.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_002_pic.jpg`,
  },
  {
    name: 'SK_Picture_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_002.jpg`,
  },
  {
    name: 'SK_Picture_003_pic.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_003_pic.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_003_pic.jpg`,
  },
  {
    name: 'SK_Picture_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_004.jpg`,
  },
  {
    name: 'SK_Picture_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Picture_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Picture_005.jpg`,
  },
  {
    name: 'K_Plant_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/K_Plant_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/K_Plant_001.jpg`,
  },
  {
    name: 'SK_PlantA_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_PlantA_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_PlantA_002.jpg`,
  },
  {
    name: 'SK_PlantC_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_PlantC_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_PlantC_001.jpg`,
  },
  {
    name: 'SK_Porcelain_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Porcelain_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Porcelain_001.jpg`,
  },
  {
    name: 'SK_Porcelain_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Porcelain_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Porcelain_002.jpg`,
  },
  {
    name: 'SK_Porcelain_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Porcelain_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Porcelain_003.jpg`,
  },
  {
    name: 'SK_Pot_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Pot_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Pot_001.jpg`,
  },
  {
    name: 'SK_Pot_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Pot_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Pot_002.jpg`,
  },
  {
    name: 'SK_Pot_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Pot_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Pot_003.jpg`,
  },
  {
    name: 'SK_Prop_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Prop_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Prop_001.jpg`,
  },
  {
    name: 'SK_Prop_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Prop_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Prop_002.jpg`,
  },
  {
    name: 'SK_Rock_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_001.jpg`,
  },
  {
    name: 'SK_Rock_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_SakuraPreview//SK_Rock_002.jpg`,
  },
  {
    name: 'SK_Rock_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_003.jpg`,
  },
  {
    name: 'SK_Rock_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_004.jpg`,
  },
  {
    name: 'SK_Rock_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_005.jpg`,
  },
  {
    name: 'SK_Rock_006.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_006.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_006.jpg`,
  },
  {
    name: 'SK_Rock_007.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_007.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_007.jpg`,
  },
  {
    name: 'SK_Rock_008.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_008.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_008.jpg`,
  },
  {
    name: 'SK_Rock_009.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_009.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_009.jpg`,
  },
  {
    name: 'SK_Rock_010.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Rock_010.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Rock_010.jpg`,
  },
  {
    name: 'SK_sakura_body.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_sakura_body.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_sakura_body.jpg`,
  },
  {
    name: 'SK_sakura_flower.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_sakura_flower.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_sakura_flower.jpg`,
  },
  {
    name: 'SK_Sakuravase.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Sakuravase.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Sakuravase.jpg`,
  },
  {
    name: 'SK_Sign_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Sign_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Sign_001.jpg`,
  },
  {
    name: 'SK_Statue_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Statue_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Statue_001.jpg`,
  },
  {
    name: 'SK_Stool_A.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Stool_A.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Stool_A.jpg`,
  },
  {
    name: 'SK_Stool_B.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Stool_B.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Stool_B.jpg`,
  },
  {
    name: 'SK_TeaTable_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_TeaTable_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_TeaTable_001.jpg`,
  },
  {
    name: 'SK_towel.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_towel.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_towel.jpg`,
  },
  {
    name: 'SK_Vase_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Vase_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Vase_001.jpg`,
  },
  {
    name: 'SK_Wall_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Wall_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Wall_001.jpg`,
  },
  {
    name: 'SK_Wall_wood_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Wall_wood_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Wall_wood_001.jpg`,
  },
  {
    name: 'SK_Wall_wood.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Wall_wood.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Wall_wood.jpg`,
  },
  {
    name: 'SK_Wall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_Wall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_Wall.jpg`,
  },
  {
    name: 'SK_WindBell_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SK_WindBell_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SK_WindBell_001.jpg`,
  },
  {
    name: 'SM_Plant_Lillypad_Large_03.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/SM_Plant_Lillypad_Large_03.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/SM_Plant_Lillypad_Large_03.jpg`,
  },
  {
    name: 'white.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/white.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/002_Sakura/Preview/white.jpg`,
  },
];

const classRoomA = [
  {
    name: 'CR_Aircon_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Aircon_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Aircon_001.jpg`,
  },
  {
    name: 'CR_Backpack_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Backpack_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Backpack_01.jpg`,
  },
  {
    name: 'CR_Backpack_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Backpack_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Backpack_02.jpg`,
  },
  {
    name: 'CR_BaseBall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BaseBall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BaseBall.jpg`,
  },
  {
    name: 'CR_BaseballBat.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BaseballBat.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BaseballBat.jpg`,
  },
  {
    name: 'CR_Basket_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Basket_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Basket_001.jpg`,
  },
  {
    name: 'CR_Basket_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Basket_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Basket_002.jpg`,
  },
  {
    name: 'CR_Basketball.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Basketball.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Basketball.jpg`,
  },
  {
    name: 'CR_Bench_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Bench_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Bench_001.jpg`,
  },
  {
    name: 'CR_BlackBoard_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BlackBoard_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BlackBoard_001.jpg`,
  },
  {
    name: 'CR_Blanket.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Blanket.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Blanket.jpg`,
  },
  {
    name: 'CR_Board_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Board_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Board_003.jpg`,
  },
  {
    name: 'CR_Book_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Book_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Book_001.jpg`,
  },
  {
    name: 'CR_Book_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Book_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Book_002.jpg`,
  },
  {
    name: 'CR_BookGroup_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_001.jpg`,
  },
  {
    name: 'CR_BookGroup_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_002.jpg`,
  },
  {
    name: 'CR_BookGroup_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_003.jpg`,
  },
  {
    name: 'CR_BookGroup_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_004.jpg`,
  },
  {
    name: 'CR_BookGroup_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_005.jpg`,
  },
  {
    name: 'CR_BookGroup_006.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_006.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_006.jpg`,
  },
  {
    name: 'CR_BookGroup_007.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_007.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_007.jpg`,
  },
  {
    name: 'CR_BookGroup_008.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_008.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_008.jpg`,
  },
  {
    name: 'CR_BookGroup_009.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_BookGroup_009.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_BookGroup_009.jpg`,
  },
  {
    name: 'CR_Bookshelf_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Bookshelf_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Bookshelf_001.jpg`,
  },
  {
    name: 'CR_Bookshelf_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Bookshelf_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Bookshelf_003.jpg`,
  },
  {
    name: 'CR_Calender.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Calender.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Calender.jpg`,
  },
  {
    name: 'CR_Catcushion_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Catcushion_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Catcushion_001.jpg`,
  },
  {
    name: 'CR_Chair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chair.jpg`,
  },
  {
    name: 'CR_Chalk_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chalk_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chalk_001.jpg`,
  },
  {
    name: 'CR_Chalk_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chalk_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chalk_002.jpg`,
  },
  {
    name: 'CR_Chalk_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chalk_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chalk_003.jpg`,
  },
  {
    name: 'CR_Chalk_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chalk_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chalk_004.jpg`,
  },
  {
    name: 'CR_Chalk_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chalk_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chalk_005.jpg`,
  },
  {
    name: 'CR_Chip_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chip_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chip_01.jpg`,
  },
  {
    name: 'CR_Chip_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Chip_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Chip_02.jpg`,
  },
  {
    name: 'CR_ClassSign_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_ClassSign_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_ClassSign_001.jpg`,
  },
  {
    name: 'CR_ClassSign_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_ClassSign_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_ClassSign_002.jpg`,
  },
  {
    name: 'CR_Clock_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Clock_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Clock_001.jpg`,
  },
  {
    name: 'CR_Clothes.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Clothes.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Clothes.jpg`,
  },
  {
    name: 'CR_Comb_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Comb_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Comb_001.jpg`,
  },
  {
    name: 'CR_CrayonBox_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_CrayonBox_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_CrayonBox_001.jpg`,
  },
  {
    name: 'CR_Desk.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Desk.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Desk.jpg`,
  },
  {
    name: 'CR_Drinking Fountain.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Drinking Fountain.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Drinking Fountain.jpg`,
  },
  {
    name: 'CR_Ecobag.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Ecobag.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Ecobag.jpg`,
  },
  {
    name: 'CR_File_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_File_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_File_001.jpg`,
  },
  {
    name: 'CR_Fireextinguisher_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Fireextinguisher_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Fireextinguisher_001.jpg`,
  },
  {
    name: 'CR_Game_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Game_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Game_001.jpg`,
  },
  {
    name: 'CR_Game_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Game_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Game_002.jpg`,
  },
  {
    name: 'CR_Giftbox_001_A.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_A.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_A.jpg`,
  },
  {
    name: 'CR_Giftbox_001_B_1.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_B_1.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_B_1.jpg`,
  },
  {
    name: 'CR_Giftbox_001_B.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_B.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_B.jpg`,
  },
  {
    name: 'CR_Giftbox_001_BalloonsA.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_BalloonsA.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_BalloonsA.jpg`,
  },
  {
    name: 'CR_Giftbox_001_BalloonsB.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_BalloonsB.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_BalloonsB.jpg`,
  },
  {
    name: 'CR_Giftbox_001_BalloonsC.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Giftbox_001_BalloonsC.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Giftbox_001_BalloonsC.jpg`,
  },
  {
    name: 'CR_Hydrantbox_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Hydrantbox_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Hydrantbox_001.jpg`,
  },
  {
    name: 'CR_LabsText_Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_LabsText_Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_LabsText_Light.jpg`,
  },
  {
    name: 'CR_Lecturedesk_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Lecturedesk_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Lecturedesk_001.jpg`,
  },
  {
    name: 'CR_LibraryText_Light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_LibraryText_Light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_LibraryText_Light.jpg`,
  },
  {
    name: 'CR_LockerA.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_LockerA.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_LockerA.jpg`,
  },
  {
    name: 'CR_LockerB_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_LockerB_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_LockerB_001.jpg`,
  },
  {
    name: 'CR_LockerB_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_LockerB_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_LockerB_002.jpg`,
  },
  {
    name: 'CR_Marker_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Marker_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Marker_001.jpg`,
  },
  {
    name: 'CR_Memo_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Memo_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Memo_001.jpg`,
  },
  {
    name: 'CR_Memo_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Memo_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Memo_002.jpg`,
  },
  {
    name: 'CR_Memo_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Memo_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Memo_003.jpg`,
  },
  {
    name: 'CR_MiniBoard_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_MiniBoard_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_MiniBoard_001.jpg`,
  },
  {
    name: 'CR_MiniBoard_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_MiniBoard_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_MiniBoard_002.jpg`,
  },
  {
    name: 'CR_Mirror_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Mirror_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Mirror_001.jpg`,
  },
  {
    name: 'CR_Mirror_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Mirror_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Mirror_002.jpg`,
  },
  {
    name: 'CR_Mirror_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Mirror_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Mirror_003.jpg`,
  },
  {
    name: 'CR_MopSet.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_MopSet.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_MopSet.jpg`,
  },
  {
    name: 'CR_Notebook_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Notebook_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Notebook_001.jpg`,
  },
  {
    name: 'CR_outplane.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_outplane.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_outplane.jpg`,
  },
  {
    name: 'CR_Paper_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Paper_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Paper_001.jpg`,
  },
  {
    name: 'CR_Paper_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Paper_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Paper_002.jpg`,
  },
  {
    name: 'CR_Paper_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Paper_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Paper_003.jpg`,
  },
  {
    name: 'CR_Pencil_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pencil_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pencil_001.jpg`,
  },
  {
    name: 'CR_Pencil_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pencil_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pencil_002.jpg`,
  },
  {
    name: 'CR_Pencilcase_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pencilcase_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pencilcase_001.jpg`,
  },
  {
    name: 'CR_Pillow_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pillow_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pillow_001.jpg`,
  },
  {
    name: 'CR_Pillow_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pillow_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pillow_002.jpg`,
  },
  {
    name: 'CR_Postit_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Postit_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Postit_001.jpg`,
  },
  {
    name: 'CR_Postit_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Postit_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Postit_002.jpg`,
  },
  {
    name: 'CR_Pot_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pot_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pot_001.jpg`,
  },
  {
    name: 'CR_Pot_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Pot_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Pot_003.jpg`,
  },
  {
    name: 'CR_RecycleBin_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_RecycleBin_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_RecycleBin_001.jpg`,
  },
  {
    name: 'CR_RecycleBin_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_RecycleBin_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_RecycleBin_002.jpg`,
  },
  {
    name: 'CR_Remotecontrol_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Remotecontrol_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Remotecontrol_001.jpg`,
  },
  {
    name: 'CR_RoomGroup_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_RoomGroup_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_RoomGroup_001.jpg`,
  },
  {
    name: 'CR_RugbyBall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_RugbyBall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_RugbyBall.jpg`,
  },
  {
    name: 'CR_ScienceBook_open.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_ScienceBook_open.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_ScienceBook_open.jpg`,
  },
  {
    name: 'CR_ScienceBook.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_ScienceBook.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_ScienceBook.jpg`,
  },
  {
    name: 'CR_Slipper_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Slipper_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Slipper_001.jpg`,
  },
  {
    name: 'CR_Slipper_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Slipper_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Slipper_002.jpg`,
  },
  {
    name: 'CR_SoccerBall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_SoccerBall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_SoccerBall.jpg`,
  },
  {
    name: 'CR_Sprinkler_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sprinkler_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sprinkler_001.jpg`,
  },
  {
    name: 'CR_Sticker_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_001.jpg`,
  },
  {
    name: 'CR_Sticker_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_002.jpg`,
  },
  {
    name: 'CR_Sticker_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_003.jpg`,
  },
  {
    name: 'CR_Sticker_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_004.jpg`,
  },
  {
    name: 'CR_Sticker_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_005.jpg`,
  },
  {
    name: 'CR_Sticker_006.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_006.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_006.jpg`,
  },
  {
    name: 'CR_Sticker_007.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_007.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_007.jpg`,
  },
  {
    name: 'CR_Sticker_008.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_008.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_008.jpg`,
  },
  {
    name: 'CR_Sticker_009.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_009.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_009.jpg`,
  },
  {
    name: 'CR_Sticker_010.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_010.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_010.jpg`,
  },
  {
    name: 'CR_Sticker_011.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_011.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_011.jpg`,
  },
  {
    name: 'CR_Sticker_012.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_012.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_012.jpg`,
  },
  {
    name: 'CR_Sticker_013.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Sticker_013.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Sticker_013.jpg`,
  },
  {
    name: 'CR_TDesk.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_TDesk.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_TDesk.jpg`,
  },
  {
    name: 'CR_TDeskChair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_TDeskChair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_TDeskChair.jpg`,
  },
  {
    name: 'CR_Towel_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Towel_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Towel_001.jpg`,
  },
  {
    name: 'CR_TRuller.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_TRuller.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_TRuller.jpg`,
  },
  {
    name: 'CR_Tumbler.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Tumbler.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Tumbler.jpg`,
  },
  {
    name: 'CR_Umbrella_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Umbrella_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Umbrella_01.jpg`,
  },
  {
    name: 'CR_Umbrella_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Umbrella_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Umbrella_02.jpg`,
  },
  {
    name: 'CR_Umbrella_03.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Umbrella_03.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Umbrella_03.jpg`,
  },
  {
    name: 'CR_UmbrellaStand.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_UmbrellaStand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_UmbrellaStand.jpg`,
  },
  {
    name: 'CR_Vendingmachine_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_Vendingmachine_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_Vendingmachine_001.jpg`,
  },
  {
    name: 'CR_WorldMap.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CR_WorldMap.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CR_WorldMap.jpg`,
  },
  {
    name: 'CRvalentines_bolloon_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CRvalentines_bolloon_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CRvalentines_bolloon_002.jpg`,
  },
  {
    name: 'CRvalentines_bouquet_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CRvalentines_bouquet_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CRvalentines_bouquet_001.jpg`,
  },
  {
    name: 'crvalentines_candy_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/crvalentines_candy_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/crvalentines_candy_001.jpg`,
  },
  {
    name: 'CRvalentines_Garland_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CRvalentines_Garland_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CRvalentines_Garland_001.jpg`,
  },
  {
    name: 'CRvalentines_Giftbox_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/CRvalentines_Giftbox_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/CRvalentines_Giftbox_002.jpg`,
  },
  {
    name: 'crvalentines_letter_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/crvalentines_letter_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/crvalentines_letter_001.jpg`,
  },
  {
    name: 'crvalentines_letter_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/crvalentines_letter_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/crvalentines_letter_002.jpg`,
  },
  {
    name: 'Minutehand.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Minutehand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/Minutehand.jpg`,
  },
  {
    name: 'Ourhand.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Ourhand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/Ourhand.jpg`,
  },
  {
    name: 'valentine_chocolet.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/valentine_chocolet.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/valentine_chocolet.jpg`,
  },
  {
    name: 'valentines_bolloon_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/valentines_bolloon_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/valentines_bolloon_001.jpg`,
  },
  {
    name: 'valentines_bolloon_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/valentines_bolloon_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/valentines_bolloon_002.jpg`,
  },
  {
    name: 'valentines_heart_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/valentines_heart_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/valentines_heart_001.jpg`,
  },
  {
    name: 'valentines_mobile_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/valentines_mobile_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/003_ClassRoomA/Preview/valentines_mobile_001.jpg`,
  },
];

const camping = [
  {
    name: 'Cam_AR_bush_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Cam_AR_bush_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/Cam_AR_bush_002.jpg`,
  },
  {
    name: 'Cam_AR_grass_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Cam_AR_grass_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/Cam_AR_grass_001.jpg`,
  },
  {
    name: 'Cam_AR_grass_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Cam_AR_grass_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/Cam_AR_grass_002.jpg`,
  },
  {
    name: 'Cam_AR_grass_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Cam_AR_grass_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/Cam_AR_grass_003.jpg`,
  },
  {
    name: 'CBS_Aobj_paddle.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CBS_Aobj_paddle.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CBS_Aobj_paddle.jpg`,
  },
  {
    name: 'CP_Campfire_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Campfire_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Campfire_01.jpg`,
  },
  {
    name: 'CP_Car_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Car_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Car_01.jpg`,
  },
  {
    name: 'CP_Chair_A.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Chair_A.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Chair_A.jpg`,
  },
  {
    name: 'CP_Chair_B.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Chair_B.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Chair_B.jpg`,
  },
  {
    name: 'CP_Chair_C.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Chair_C.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Chair_C.jpg`,
  },
  {
    name: 'CP_Fish_trap.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Fish_trap.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Fish_trap.jpg`,
  },
  {
    name: 'CP_fishing_deck.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_fishing_deck.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_fishing_deck.jpg`,
  },
  {
    name: 'CP_Fishing_rod.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Fishing_rod.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Fishing_rod.jpg`,
  },
  {
    name: 'CP_Grill_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Grill_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Grill_01.jpg`,
  },
  {
    name: 'CP_Ground.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Ground.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Ground.jpg`,
  },
  {
    name: 'CP_Lamp_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Lamp_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Lamp_01.jpg`,
  },
  {
    name: 'CP_Lamp_light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Lamp_light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Lamp_light.jpg`,
  },
  {
    name: 'CP_led_lgiht_02.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_led_lgiht_02.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_led_lgiht_02.jpg`,
  },
  {
    name: 'CP_Led_Object.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Led_Object.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Led_Object.jpg`,
  },
  {
    name: 'CP_Out_bg.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Out_bg.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Out_bg.jpg`,
  },
  {
    name: 'CP_Path_light_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Path_light_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Path_light_01.jpg`,
  },
  {
    name: 'CP_Stone_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Stone_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Stone_01.jpg`,
  },
  {
    name: 'CP_Tent_01.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Tent_01.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Tent_01.jpg`,
  },
  {
    name: 'CP_Tent_lamp_glass.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Tent_lamp_glass.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Tent_lamp_glass.jpg`,
  },
  {
    name: 'CP_Tent_light.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Tent_light.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Tent_light.jpg`,
  },
  {
    name: 'CP_Water_fx.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Water_fx.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Water_fx.jpg`,
  },
  {
    name: 'CP_Wood_Pence.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/CP_Wood_Pence.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/CP_Wood_Pence.jpg`,
  },
  {
    name: 'FX_CP_Led_Object.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/FX_CP_Led_Object.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/FX_CP_Led_Object.jpg`,
  },
  {
    name: 'HG_CU_Guitar_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/HG_CU_Guitar_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/HG_CU_Guitar_001.jpg`,
  },
  {
    name: 'leaves_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/leaves_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/leaves_001.jpg`,
  },
  {
    name: 'leaves_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/leaves_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/leaves_002.jpg`,
  },
  {
    name: 'RED_HalfSphere_basic.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/RED_HalfSphere_basic.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/RED_HalfSphere_basic.jpg`,
  },
  {
    name: 'trunk_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/trunk_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/trunk_001.jpg`,
  },
  {
    name: 'trunk_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/trunk_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/004_Camping/Preview/trunk_002.jpg`,
  },
];

const fall = [
  {
    name: 'CBS_cafe_1F_Table.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_Table.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_Table.jpg`,
  },
  {
    name: 'CBS_cafe_1F_TableChair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_TableChair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_TableChair.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Tree.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_Tree.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_Tree.jpg`,
  },
  {
    name: 'CBS_cafe_1F_TreeChair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_TreeChair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_TreeChair.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Wall_Summer.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_Wall_Summer.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_Wall_Summer.jpg`,
  },
  {
    name: 'CBS_cafe_1F_Wall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_1F_Wall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_1F_Wall.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Chair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_2F_Chair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_2F_Chair.jpg`,
  },
  {
    name: 'CBS_cafe_2F_SideTable.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_2F_SideTable.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_2F_SideTable.jpg`,
  },
  {
    name: 'CBS_cafe_2F_SideWall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_2F_SideWall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_2F_SideWall.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Table.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_2F_Table.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_2F_Table.jpg`,
  },
  {
    name: 'CBS_cafe_2F_Tree.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_2F_Tree.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_2F_Tree.jpg`,
  },
  {
    name: 'CBS_cafe_Flowerpot_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_Flowerpot_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_Flowerpot_S.jpg`,
  },
  {
    name: 'CBS_cafe_Light_LoofTop.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_Light_LoofTop.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_Light_LoofTop.jpg`,
  },
  {
    name: 'CBS_cafe_Light_Stand.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_Light_Stand.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_Light_Stand.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk_coffepot.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_MainDesk_coffepot.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_MainDesk_coffepot.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk_galss.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_MainDesk_galss.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_MainDesk_galss.jpg`,
  },
  {
    name: 'CBS_cafe_MainDesk.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_MainDesk.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_MainDesk.jpg`,
  },
  {
    name: 'CBS_cafe_MenuSign.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_MenuSign.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_MenuSign.jpg`,
  },
  {
    name: 'CBS_cafe_pos.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_pos.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_pos.jpg`,
  },
  {
    name: 'CBS_cafe_Stair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_cafe_Stair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_cafe_Stair.jpg`,
  },
  {
    name: 'CBS_Fall_Leaf.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Fall_Leaf.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Fall_Leaf.jpg`,
  },
  {
    name: 'CBS_Fall_Leaf001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Fall_Leaf001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Fall_Leaf001.jpg`,
  },
  {
    name: 'CBS_ground_bridge_1.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_ground_bridge_1.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_ground_bridge_1.jpg`,
  },
  {
    name: 'CBS_ground_bridge_2.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_ground_bridge_2.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_ground_bridge_2.jpg`,
  },
  {
    name: 'CBS_Ground_CheckWall.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_CheckWall.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_CheckWall.jpg`,
  },
  {
    name: 'CBS_Ground_cliff.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_cliff.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_cliff.jpg`,
  },
  {
    name: 'CBS_Ground_hill.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_hill.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_hill.jpg`,
  },
  {
    name: 'CBS_ground_outside_sky.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_ground_outside_sky.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_ground_outside_sky.jpg`,
  },
  {
    name: 'CBS_Ground_rock_BIG.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_rock_BIG.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_rock_BIG.jpg`,
  },
  {
    name: 'CBS_Ground_rock_BIG2.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_rock_BIG2.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_rock_BIG2.jpg`,
  },
  {
    name: 'CBS_Ground_rock_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground_rock_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground_rock_S.jpg`,
  },
  {
    name: 'CBS_ground_stair.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_ground_stair.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_ground_stair.jpg`,
  },
  {
    name: 'CBS_Ground.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Ground.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Ground.jpg`,
  },
  {
    name: 'CBS_nat_Rock_A.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_nat_Rock_A.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_nat_Rock_A.jpg`,
  },
  {
    name: 'CBS_nat_Rock_B.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_nat_Rock_B.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_nat_Rock_B.jpg`,
  },
  {
    name: 'CBS_obj_Airfield.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_Airfield.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_Airfield.jpg`,
  },
  {
    name: 'CBS_obj_Bench.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_Bench.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_Bench.jpg`,
  },
  {
    name: 'CBS_obj_Marina.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_Marina.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_Marina.jpg`,
  },
  {
    name: 'CBS_obj_StreetLight_L.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_StreetLight_L.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_StreetLight_L.jpg`,
  },
  {
    name: 'CBS_obj_StreetLight_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_StreetLight_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_StreetLight_S.jpg`,
  },
  {
    name: 'CBS_Obj_Swing_Hook.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Obj_Swing_Hook.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Obj_Swing_Hook.jpg`,
  },
  {
    name: 'CBS_Obj_Swing.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Obj_Swing.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Obj_Swing.jpg`,
  },
  {
    name: 'CBS_obj_WiretLight_L.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_WiretLight_L.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_WiretLight_L.jpg`,
  },
  {
    name: 'CBS_obj_WiretLight_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_WiretLight_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_WiretLight_S.jpg`,
  },
  {
    name: 'CBS_obj_wood_fence.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_obj_wood_fence.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_obj_wood_fence.jpg`,
  },
  {
    name: 'CBS_Plant_cafewall_ALP.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Plant_cafewall_ALP.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Plant_cafewall_ALP.jpg`,
  },
  {
    name: 'CBS_Plant_cafewall_ALP001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_Plant_cafewall_ALP001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_Plant_cafewall_ALP001.jpg`,
  },
  {
    name: 'CBS_water_FX.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/CBS_water_FX.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/CBS_water_FX.jpg`,
  },
  {
    name: 'FSF_leaves_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_leaves_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_leaves_001.jpg`,
  },
  {
    name: 'FSF_leaves_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_leaves_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_leaves_002.jpg`,
  },
  {
    name: 'FSF_leaves_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_leaves_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_leaves_004.jpg`,
  },
  {
    name: 'FSF_leves_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_leves_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_leves_003.jpg`,
  },
  {
    name: 'FSF_trunk_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_trunk_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_trunk_001.jpg`,
  },
  {
    name: 'FSF_trunk_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_trunk_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_trunk_002.jpg`,
  },
  {
    name: 'FSF_trunk_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSF_trunk_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSF_trunk_004.jpg`,
  },
  {
    name: 'FSS_Flower_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_Flower_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_Flower_004.jpg`,
  },
  {
    name: 'FSS_grass_01_a.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_grass_01_a.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_grass_01_a.jpg`,
  },
  {
    name: 'FSS_grass_01_c.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_grass_01_c.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_grass_01_c.jpg`,
  },
  {
    name: 'FSS_grass_01_d.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_grass_01_d.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_grass_01_d.jpg`,
  },
  {
    name: 'FSS_grass_01_e.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_grass_01_e.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_grass_01_e.jpg`,
  },
  {
    name: 'FSS_obj_StreetLight_S.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_obj_StreetLight_S.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_obj_StreetLight_S.jpg`,
  },
  {
    name: 'FSS_obj_WiretLight_L.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_obj_WiretLight_L.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_obj_WiretLight_L.jpg`,
  },
  {
    name: 'FSS_WiretLight.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/FSS_WiretLight.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/FSS_WiretLight.jpg`,
  },
  {
    name: 'Object003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Object003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/Object003.jpg`,
  },
  {
    name: 'Object005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Object005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/Object005.jpg`,
  },
  {
    name: 'Object608.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Object608.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/005_Fall/Preview/Object608.jpg`,
  },
];

const sampleMap = [
  {
    name: 'TEST_Map_001_Cage_1X1.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/TEST_Map_001_Cage_1X1.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/Preview/TEST_Map_001_Cage_1X1.jpg`,
  },
  {
    name: 'TEST_Map_001_Cage_1X10.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/TEST_Map_001_Cage_1X10.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/Preview/TEST_Map_001_Cage_1X10.jpg`,
  },
  {
    name: 'TEST_Map_001_Cage_1X2.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/TEST_Map_001_Cage_1X2.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/Preview/TEST_Map_001_Cage_1X2.jpg`,
  },
  {
    name: 'TEST_Map_001_Cage_1X4.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/TEST_Map_001_Cage_1X4.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/100_SampleMap/Preview/TEST_Map_001_Cage_1X4.jpg`,
  },
];

const baseCamp = [
  {
    name: 'AR_bush_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_bush_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_bush_001.jpg`,
  },
  {
    name: 'AR_bush_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_bush_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_bush_002.jpg`,
  },
  {
    name: 'AR_Flowers_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_Flowers_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_Flowers_001.jpg`,
  },
  {
    name: 'AR_Flowers_002.glb',
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_Flowers_002.jpg`,
  },
  {
    name: 'AR_Flowers_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_Flowers_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_Flowers_003.jpg`,
  },
  {
    name: 'AR_Flowers_004.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_Flowers_004.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_Flowers_004.jpg`,
  },
  {
    name: 'AR_Flowers_005.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_Flowers_005.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_Flowers_005.jpg`,
  },
  {
    name: 'AR_grass_001.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_grass_001.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_grass_001.jpg`,
  },
  {
    name: 'AR_grass_002.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_grass_002.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_grass_002.jpg`,
  },
  {
    name: 'AR_grass_003.glb',
    url: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/AR_grass_003.glb`,
    image: `${CDN_MARKETPLACE}/zepeto-collections/BaseCamp_001/Preview/AR_grass_003.jpg`,
  },
];

export const zepetoItems = {
  pack1,
  commonObject,
  sample,
  desert,
  sakura,
  classRoomA,
  camping,
  fall,
  sampleMap,
  baseCamp,
};
